import { render, staticRenderFns } from "./layout-main.vue?vue&type=template&id=65c4867a&scoped=true&"
import script from "./layout-main.vue?vue&type=script&lang=js&"
export * from "./layout-main.vue?vue&type=script&lang=js&"
import style0 from "./layout-main.vue?vue&type=style&index=0&id=65c4867a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4867a",
  null
  
)

export default component.exports